/**
 * @fileoverview ClubOS application entry point
 * Wraps the app in AuthProvider (RBAC) + SoftUIControllerProvider (theme/layout).
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Chart.js 3 requires explicit registration of all used components
import {
  Chart,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  BarController,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

Chart.register(
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  BarController,
  Title,
  Tooltip,
  Legend,
  Filler
);

// ClubOS Auth & RBAC context
import { AuthProvider } from "context/AuthContext";

// ClubOS Context Provider
import { SoftUIControllerProvider } from "context";

// PWA service worker
import { registerSW } from "./pwa";
registerSW();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AuthProvider>
      <SoftUIControllerProvider>
        <App />
      </SoftUIControllerProvider>
    </AuthProvider>
  </BrowserRouter>
);
